import { SubtypeDefinition } from "../actionModule";
import { BaseModuleSubtype } from "../subtypes/subtype";

export interface SubtypeState {
    definition: SubtypeDefinition;
    subtype: EditorModuleSubtype;
    properties: {
        [key: string]: PropertyType
    },
    index: number;
    editorId: number;
}

export interface SubtypeProperty {
    /**
     * The internal name of this property. This name is used in request / response and state models.
     */
    name: string;

    /**
     * The name of this property which is shown to the user. This is a localization key.
     */
    displayName: string;

    /**
     * Defines the type of property which is edited here. Basic types are supported, if this
     * subtype property represents some more advanced state, use PropertyType.complex in conjunction
     * with a custom editor and complexEditorStateToModel / complexModelToEditorState functions.
     */
    propertyType: PropertyTypes;

    /**
     * Defines a default value which is used on initialization on the new subtype
     */
    defaultValue?: PropertyType;

    /**
     * Defines the editor which the user can use to edit the property value. If no editor
     * is provided, a default editor Component is decided based on the propertyType
     */
    editor?: (props: PropertyEditorProps) => React.ReactElement;

    /**
     * Defines an optional mapping function which maps from the internal editor state
     * to the model value which is sent to the API
     */
    complexEditorStateToModel?: (value: PropertyType) => unknown;

    /**
     * Defines an optional mapping function which maps from the API model to the internal
     * editor state
     */
    complexModelToEditorState?: (value: unknown) => PropertyType;
}

export enum PropertyTypes {
    text,
    boolean,
    integer,
    complex,
}

export type PropertyType = string | boolean | number | object | [] | null;

export interface PropertyEditorProps {
    property: SubtypeProperty;
    subtype: SubtypeState;
    onChanged: (newState: PropertyType | undefined) => void;
    value: PropertyType;
}

export type EditorModuleSubtype = Omit<BaseModuleSubtype, "subtype" | "id" | "order"> & {
    id: number | null;
};